import axios from 'axios';
import { config } from '../shared/app.config';
import store from '../store/store';

const RESOURCE_NAME = '/app/sales';
const RESOURCE_NAME_PUBLIC = '/webadmin/public/daymenus';

export default {
    getAllByRestaurant(restaurant_id, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        return axios.get(`${config.webApiBase + RESOURCE_NAME  }/all/${restaurant_id}`, {
            headers: {
                'X-localization': language
            }
        });
    },

    getUsers() {
        return axios.get(`${config.webApiBase}/users`, {
            headers: {
                'X-localization': language
            }
        });
    },
    assignUser(saleInfo) {

        return axios.post(config.webApiBase + RESOURCE_NAME + `/assign`, saleInfo)

    },

    getSale(id, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language
            }
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME }/${  id}`, requestConfig)
    },


    create(sale, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language
            }
        };

        return axios.post(config.webApiBase + RESOURCE_NAME + `/create`, sale, requestConfig);
    },
    delete(id) {
        return axios.get(`${config.webApiBase + RESOURCE_NAME }/delete/${  id}`);
    },
    edit(id, sale, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language
            }
        };
        sale.model = 'put';
        return axios.post(`${config.webApiBase + RESOURCE_NAME  }/edit/${  id}`, sale, requestConfig);
    }
}